import Head from 'next/head';

const AnalyticsScriptInjector = ({ template_settings = {} }) => {
    const google_conversion = template_settings?.google_conversion === 'yes';
    const google_conversion_id = template_settings?.google_conversion_id ?? '';
    const google_conversion_label = template_settings?.google_conversion_label ?? '';
    const {
        ga_measurement_id,
        gtm_id,
        bing_uet_tag,
        enableAutoSpaTracking = true,
    } = template_settings || {};

    if (!gtm_id && !ga_measurement_id && !bing_uet_tag && !google_conversion) {
        return null;
    }

    return (
        <>
        {gtm_id && (
            <Head>
                <script
                    type="text/partytown"
                    id="gtm-worker"
                    dangerouslySetInnerHTML={{
                    __html: `
                        (function(){
                        if (window.__GTM_BOOTED__ || window.google_tag_manager) return;
                        window.__GTM_BOOTED__ = true;
                        (function(w,d,s,l,i){
                            w[l]=w[l]||[];
                            w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
                            var f=d.getElementsByTagName(s)[0],
                                j=d.createElement(s), dl=l!='dataLayer'?'&l='+l:'';
                            j.async=true;
                            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
                            f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','${gtm_id}');
                        })();
                    `,
                    }}
                />
            </Head>
        )}

        {!gtm_id && ga_measurement_id && (
            <Head>
                <script
                    type="text/partytown"
                    id="ga4-src"
                    src={`https://www.googletagmanager.com/gtag/js?id=${ga_measurement_id}`}
                />
                <script
                    type="text/partytown"
                    id="ga4-inline"
                    dangerouslySetInnerHTML={{
                    __html: `
                        (function(){
                        if (window.__GTAG_BOOTED__) return;
                        window.__GTAG_BOOTED__ = true;
                        gtag('js', new Date());
                        gtag('config', '${ga_measurement_id}', { send_page_view: true });
                        })();
                    `,
                    }}
                />
            </Head>
        )}

        {bing_uet_tag && (
            <Head>
                <script
                    type="text/partytown"
                    id="bing-uet-inline"
                    dangerouslySetInnerHTML={{
                    __html: `
                        (function(w,d,t){
                        if (w.__UET_BOOTED__) return;
                        function boot(){
                            if (w.__UET_BOOTED__) return;
                            w.__UET_BOOTED__ = true;

                            var u='uetq'; w[u]=w[u]||[];
                            var f=function(){
                            var o={ti:"${bing_uet_tag}"${enableAutoSpaTracking ? ", enableAutoSpaTracking: true" : ""}};
                            o.q=w[u]; w[u]=new UET(o); w[u].push("pageLoad");
                            };
                            var n=d.createElement(t); n.src="https://bat.bing.com/bat.js"; n.async=1;
                            n.onload=n.onreadystatechange=function(){
                            var s=this.readyState;
                            if(!s || s==="loaded" || s==="complete"){ f(); n.onload=n.onreadystatechange=null; }
                            };
                            var i=d.getElementsByTagName(t)[0]; i.parentNode.insertBefore(n,i);
                        }

                        // Run after onload; small idle delay to avoid racing with GTM/GA
                        function afterLoad(){
                            if ('requestIdleCallback' in w) {
                            w.requestIdleCallback(boot, { timeout: 2000 });
                            } else {
                            setTimeout(boot, 300);
                            }
                        }

                        if (d.readyState === 'complete') {
                            afterLoad();
                        } else {
                            w.addEventListener('load', afterLoad);
                        }
                        })(window,document,'script');
                    `,
                    }}
                />
            </Head>
        )}

        {google_conversion && google_conversion_id && google_conversion_label && (
            <Head>
                <script
                    type="text/partytown"
                    id="google-conversion-src"
                    src="//www.googleadservices.com/pagead/conversion_async.js"
                />
                <script
                    type="text/partytown"
                    id="google-conversion-inline"
                    dangerouslySetInnerHTML={{
                    __html: `
                        (function(){
                        if (window.__GOOG_CONV_BOOTED__) return;
                        window.__GOOG_CONV_BOOTED__ = true;

                        window.goog_snippet_vars = function() {
                            var w = window;
                            w.google_conversion_id = ${Number(google_conversion_id)};
                            w.google_conversion_label = "${google_conversion_label}";
                            w.google_remarketing_only = false;
                        };

                        window.goog_report_conversion = function(url) {
                            goog_snippet_vars();
                            window.google_conversion_format = "3";
                            var opt = {};
                            opt.onload_callback = function() {
                            if (typeof url !== 'undefined') {
                                window.location = url;
                            }
                            };
                            var conv_handler = window['google_trackConversion'];
                            if (typeof conv_handler === 'function') {
                            conv_handler(opt);
                            }
                        };
                        })();
                    `,
                    }}
                />
            </Head>
        )}
        </>
    );
};

export default AnalyticsScriptInjector;
